module.exports = __webpack_public_path__ + "img/add_white_box.4c2e233e.svg";